<div
  *ngIf="!privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
  fxLayout="column"
  fxLayoutAlign="center center">
  You are not allowed to add / edit this module notification.
</div>
<div
  *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL) ||
          privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.VIEW)"
  class="module-notification-form__form"
  fxLayout="column"
  fxLayoutGap="30px"
  fxLayoutAlign="center">
  <div *ngIf="openNotification" fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="20px">
    <div class="notification-card">
      <div class="notification-card-header"
           (click)="expandNotification('opening', openNotification)">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column">
            <strong>Open Notification</strong>
          </div>
          <mat-icon *ngIf="openNotificationCardView.expand">
            expand_less
          </mat-icon>
          <mat-icon *ngIf="!openNotificationCardView.expand">
            expand_more
          </mat-icon>
        </div>
      </div>
      <mat-card class="mat-elevation-z0" fxLayout="row">
        <mat-card-content *ngIf="openNotificationCardView.expand" fxFlex="100" fxLayoutGap="30px">
          <div *ngIf="openNotificationCardView.errors">
            <div *ngFor="let error of openNotificationCardView.errors">
              <span class="dashboard-timing-rules-dialog__content-error">
               {{ error }}
              </span>
            </div>
          </div>
          <a class="module-notification-form__form-remove" (click)="removeOpenNotification(openNotification)">
            <mat-icon [matTooltip]="'This button will delete and clear the Open notification'"
                      matTooltipPosition="above">
              close
            </mat-icon>
          </a>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="100">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column" fxFlex="20">
                  <div fxLayout="row"
                       fxLayoutAlign="start center">
                    <mat-button-toggle-group (change)="selectTemplateLanguage($event)"
                                             value="{{selectedLanguage.code}}">
                      <mat-button-toggle *ngFor="let language of supportedLanguages; let i = index"
                                         value="{{language.code}}"
                                         [disableRipple]="true">
                        {{supportedLanguages.length > 2 ? language.code.toUpperCase() : language.name}}
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="70">
                  <strong class="notification-description">
                    When the module becomes available for the participant, a open notification will be sent.
                    <br>
                    If you want to add custom text to the open notifications, fill in the details below. Otherwise leave
                    blank.
                  </strong>
                </div>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center">
                <div fxLayout="column" fxFlex="100">
                  <div *ngFor="let language of openNotification.text; let i = index">
                    <mat-form-field
                      *ngIf="language.languageCode === selectedLanguage.code"
                      fxFill>
                      <input
                        [disabled]="viewOnly"
                        [(ngModel)]="openNotification.text[i].text"
                        matInput
                        placeholder="Open notification text in {{selectedLanguage.name}}"/>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div *ngIf="closeNotification"
       fxLayout="column"
       fxLayoutAlign="space-around"
       fxLayoutGap="20px">
    <div class="notification-card">
      <div class="notification-card-header"
           (click)="expandNotification('closing', closeNotification)">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column">
            <strong>Close Notification</strong>
          </div>
          <mat-icon *ngIf="closeNotificationCardView.expand">
            expand_less
          </mat-icon>
          <mat-icon *ngIf="!closeNotificationCardView.expand">
            expand_more
          </mat-icon>
        </div>
      </div>
      <mat-card class="mat-elevation-z0" fxLayout="row">
        <mat-card-content *ngIf="closeNotificationCardView.expand" fxFlex="100" fxLayoutGap="30px">
          <div *ngIf="closeNotificationCardView.errors">
            <div *ngFor="let error of closeNotificationCardView.errors">
              <span class="dashboard-timing-rules-dialog__content-error">
               {{ error }}
              </span>
            </div>
          </div>
          <a class="module-notification-form__form-remove" (click)="removeCloseNotification(closeNotification)">
            <mat-icon [matTooltip]="'This button will delete and clear the Close notification'"
                      matTooltipPosition="above">
              close
            </mat-icon>
          </a>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="100">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column" fxFlex="20">
                  <div fxLayout="row"
                       fxLayoutAlign="start center"
                       style="margin-bottom: 10px">
                    <mat-button-toggle-group (change)="selectTemplateLanguage($event)"
                                             value="{{selectedLanguage.code}}">
                      <mat-button-toggle *ngFor="let language of supportedLanguages; let i = index"
                                         value="{{language.code}}"
                                         [disableRipple]="true">
                        {{supportedLanguages.length > 2 ? language.code.toUpperCase() : language.name}}
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="60">
                  <strong class="notification-description">
                    When a module is about to close, a close notification can be sent.
                    <br>
                    If you want to enable close notifications, fill in the details below. Otherwise leave blank.
                  </strong>
                </div>
                <div fxLayout="column" fxFlex="20">
                  <mat-select [value]="'interval'"
                              [(ngModel)]="closeNotification.timing_type"
                              (ngModelChange)="changeTimingType($event, closeNotification)">
                    <mat-option [value]="'interval'">Time period</mat-option>
                    <mat-option [value]="'date'">Specific date</mat-option>
                  </mat-select>
                </div>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center">
                <div fxLayout="column" fxFlex="100">
                  <div *ngFor="let language of closeNotification.text; let i = index">
                    <mat-form-field
                      *ngIf="language.languageCode === selectedLanguage.code"
                      fxFill>
                      <input
                        [disabled]="viewOnly"
                        [(ngModel)]="language.text"
                        matInput
                        placeholder="Close notification text in {{selectedLanguage.name}}"/>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div *ngIf="closeNotification.timing_type === INTERVAL_TIMING_TYPE"
                   class="notification-time-inputs"
                   fxLayout="row"
                   fxLayoutAlign="start center">
                <div fxLayout="column"
                     fxFlex="20">
                  <label class="module-notification-form__form-label">Send close notification </label>
                </div>
                <div fxLayout="column" fxFlex="60">
                  <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
                    <div *ngFor="let unit of TIMER_ARRAY_UNITS" fxFlex="20">
                      <mat-form-field fxFill>
                        <input [disabled]="viewOnly"
                               matInput
                               type="number"
                               placeholder="{{ unit }}"
                               [min]="0"
                               [(ngModel)]="closeNotification[unit]"/>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="1">
                </div>
                <div fxLayout="column" fxFlex="15">
                  <label class="module-notification-form__form-label">before it closes.</label>
                </div>
              </div>
              <div *ngIf="closeNotification.timing_type === DATE_TIMING_TYPE"
                   class="notification-time-inputs"
                   fxLayout="row"
                   fxLayoutAlign="start center">
                <div fxLayout="column"
                     fxFlex="20">
                  <label class="module-notification-form__form-label">Send close notification at</label>
                </div>
                <div fxLayout="column" fxFlex="20">
                  <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
                    <input
                      matInput
                      placeholder="Select date and time"
                      [ngxMatDatetimePicker]="closeDatePicker"
                      [(ngModel)]="closeNotification.date"
                      (ngModelChange)="addDateToNotification($event, closeNotification)"
                      [min]="now"
                      [max]="moduleClosingDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="closeDatePicker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #closeDatePicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
                    </ngx-mat-datetime-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div
    *ngFor="let reminderNotification of reminderNotifications; let i = index"
    fxLayout="column"
    fxLayoutAlign="space-around"
    fxLayoutGap="20px">
    <div class="notification-card">
      <div class="notification-card-header"
           (click)="expandNotification('reminder', reminderNotification)">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column">
            <strong>Reminder Notification {{i + 1}}</strong>
          </div>
          <div fxLayout="column">
            <mat-icon *ngIf="getExpandReminder(reminderNotification)">
              expand_less
            </mat-icon>
            <mat-icon *ngIf="!getExpandReminder(reminderNotification)">
              expand_more
            </mat-icon>
          </div>
        </div>
      </div>
      <mat-card class="mat-elevation-z0" fxLayout="row">
        <mat-card-content *ngIf="getExpandReminder(reminderNotification)" fxFlex="100" fxLayoutGap="30px">
          <div *ngIf="getReminderErrors(reminderNotification)">
            <div *ngFor="let error of getReminderErrors(reminderNotification)">
              <span class="dashboard-timing-rules-dialog__content-error">
               {{ error }}
              </span>
            </div>
          </div>
          <a class="module-notification-form__form-remove" (click)="removeReminderNotification(reminderNotification)">
            <mat-icon [matTooltip]="'This button will delete and remove the Reminder notification'"
                      matTooltipPosition="above">
              close
            </mat-icon>
          </a>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="100">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column" fxFlex="20">
                  <div fxLayout="row"
                       fxLayoutAlign="start center"
                       style="margin-bottom: 10px">
                    <mat-button-toggle-group (change)="selectTemplateLanguage($event)"
                                             value="{{selectedLanguage.code}}">
                      <mat-button-toggle *ngFor="let language of supportedLanguages; let i = index"
                                         value="{{language.code}}"
                                         [disableRipple]="true">
                        {{supportedLanguages.length > 2 ? language.code.toUpperCase() : language.name}}
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="60">
                  <strong class="notification-description">
                    When a participant doesn't answer the module, a reminder notification can be sent.
                    <br>
                    If you want to enable reminder notifications, fill in the details below. Otherwise leave blank.
                  </strong>
                </div>
                <div fxLayout="column" fxFlex="20">
                  <mat-select [value]="'interval'"
                              [(ngModel)]="reminderNotification.timing_type"
                              (ngModelChange)="changeTimingType($event, reminderNotification)">
                    <mat-option [value]="'interval'">Time period</mat-option>
                    <mat-option [value]="'date'">Specific date</mat-option>
                  </mat-select>
                </div>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center">
                <div fxLayout="column" fxFlex="100">
                  <div *ngFor="let language of reminderNotification.text; let i = index">
                    <mat-form-field
                      *ngIf="selectedLanguage.code === language.languageCode"
                      fxFill>
                      <input
                        [disabled]="viewOnly"
                        [(ngModel)]="language.text"
                        matInput
                        placeholder="Reminder notification text in {{selectedLanguage.name}}"/>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div *ngIf="reminderNotification.timing_type === INTERVAL_TIMING_TYPE"
                   class="notification-time-inputs"
                   fxLayout="row"
                   fxLayoutAlign="start center">
                <div fxLayout="column" fxFlex="20">
                  <label class="module-notification-form__form-label">Send reminder after</label>
                </div>
                <div fxLayout="column" fxLayoutGap="10px">
                  <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
                    <div *ngFor="let unit of TIMER_ARRAY_UNITS" fxFlex="20">
                      <mat-form-field fxFill>
                        <input [disabled]="viewOnly"
                               matInput
                               type="number"
                               placeholder="{{ unit }}"
                               [min]="0"
                               [(ngModel)]="reminderNotification[unit]"/>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="reminderNotification.timing_type === DATE_TIMING_TYPE"
                   class="notification-time-inputs"
                   fxLayout="row"
                   fxLayoutAlign="start center">
                <div fxLayout="column"
                     fxFlex="20">
                  <label class="module-notification-form__form-label">Send reminder notification at</label>
                </div>
                <div fxLayout="column" fxFlex="20">
                  <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
                    <input
                      matInput
                      placeholder="Select date and time"
                      [ngxMatDatetimePicker]="reminderDatePicker"
                      [(ngModel)]="reminderNotification.date"
                      (ngModelChange)="addDateToNotification($event, reminderNotification)"
                      [min]="now"
                    />
                    <mat-datepicker-toggle matSuffix [for]="reminderDatePicker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #reminderDatePicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
                    </ngx-mat-datetime-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div
    fxLayout="column"
    fxLayoutAlign="center center">
    <button mat-button color="primary" (click)="addReminderNotification(null)">
      {{ 'Add reminder notification' | uppercase }}
    </button>
  </div>
</div>
